function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVyper = function SvgVyper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Transparent Logo",
    viewBox: "0 0 2048 1773.62"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m1024 886.81-256 443.41 256 443.4 256-443.4-256-443.41z",
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1280 443.41-256 443.4 256 443.41 256-443.41-256-443.4zm-512 0-256 443.4 256 443.41 256-443.41-256-443.4z",
    style: {
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1536 0-256 443.41 256 443.4 256-443.4L1536 0zm-384 221.7H896L768 443.41l256 443.4 256-443.4-128-221.71zM512 0 256 443.41l256 443.4 256-443.4L512 0z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792 443.4 2048 0h-512l256 443.4zm-1536 0L512 0H0l256 443.4z",
    style: {
      opacity: 0.3
    }
  }));
};
export default SvgVyper;